import React, { ReactElement } from 'react'
import DateRangeFilter, { DateRangeFilterProps } from '../date-range-filter'
import { WhatsHappeningMultiFilterProps } from '../whats-happening-multi-filter'
import WhatsHappeningMultiFilterV2 from '../whats-happening-multi-filter-v2'
import trackClickEvent from '../../helpers/analytics-utils/track-event'
import { categories, actions } from '../../helpers/analytics-utils/constants'
import WhatsHappeningFiltersWrapper from './wrapper'
import styles from './index.module.scss'
import { Button } from '@hub/button'
import { Text } from '@hub/text'

export interface SelectedFilter {
  selectedFilters: string
  onFiltersChange: (selectedTypes: string) => void
}

interface WhatsHappeningFiltersProps {
  dateRangeProps: DateRangeFilterProps
  contentTypesProps: WhatsHappeningMultiFilterProps
  topicsProps: WhatsHappeningMultiFilterProps
  experiencesProps: WhatsHappeningMultiFilterProps
  onResetFilters: () => void
}

const trackReset = (): void => {
  trackClickEvent(
    categories.WHATS_HAPPENING_FILTERS,
    actions.RESET_FILTERS,
    undefined
  )
}
const WhatsHappeningFilters = ({
  dateRangeProps,
  onResetFilters,
  contentTypesProps,
  topicsProps,
  experiencesProps,
}: WhatsHappeningFiltersProps): ReactElement => {
  const count = [contentTypesProps, topicsProps, experiencesProps].reduce(
    (a, c) => a + (c?.selectedOptions || []).length,
    0
  )

  return (
    <WhatsHappeningFiltersWrapper count={count}>
      <>
        <DateRangeFilter {...dateRangeProps} />
        <WhatsHappeningMultiFilterV2 {...contentTypesProps} />
        <WhatsHappeningMultiFilterV2 {...topicsProps} />
        <WhatsHappeningMultiFilterV2 {...experiencesProps} />

        <div className={styles.reset}>
          <Button
            variant="transparent"
            colorScheme="surfacePrimaryWithText"
            sx={{
              fontWeight: 'lighter',
              textTransform: 'initial',
              paddingY: 'spacing-md',
              width: 'size-full',
              height: 'size-9',
            }}
            onClick={() => {
              onResetFilters()
              trackReset()
            }}
          >
            <Text
              sx={{
                color: 'inherit',
                boxShadow: `0 1px 0, 0 2px 0`,
              }}
            >
              Reset filters
            </Text>
          </Button>
        </div>
      </>
    </WhatsHappeningFiltersWrapper>
  )
}

export default WhatsHappeningFilters
